import * as React from "react";
import { cn } from "../../lib/utils";

export const Input = React.forwardRef(function Input(
  { className, ...props }, ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        "w-full h-12 rounded-lg bg-[hsl(var(--bg-elev-2))] border border-[hsl(var(--border))] px-4 text-sm font-mono tracking-tight text-[hsl(var(--fg))] placeholder:text-[hsl(var(--muted))] outline-none transition-[border-color,box-shadow] duration-150 focus:border-[hsl(var(--primary))] focus:ring-2 focus:ring-[hsl(var(--primary)/0.35)]",
        className
      )}
      {...props}
    />
  );
});
